import React, { useEffect, useState, useContext, useCallback, useMemo } from 'react'
import styled, { ThemeContext } from 'styled-components'

import { useActiveWeb3React } from '../../../hooks'
import useUserArtworks from '../../../hooks/user/useUserArtworks'
import { getArtworksV2 } from '../../../service/nft'
import { UserTabOptions, AuctionBake, ArtworkProps } from '../../../constants/artwork'
import { contractAddresses } from '../../../sushi/lib/constants'
import Search from '../../Restaurant/components/Search'
import InfiniteScroll from '../../../components/view/InfiniteScroll'

import Row from '../../../components/Row'
import NoArtwork from './NoArtwork'
import Loading from '../../../components/Loader/Loading'
import SortPets from '../../Pet/components/SortPets'
import ArtworkCard from '../../../components/Collection/ArtworkCard'

const ArtworkList = styled.div`
  display: grid;
  grid-row-gap: 20px;
  grid-column-gap: 20px;
  justify-content: space-between;
  grid-template-columns: repeat(auto-fill, 272px);
  ${({ theme }) => theme.mediaWidth.upToSmall`
    justify-content: center;
  `}
`
const MyEggsRow = styled(Row)`
  align-items: center;
  flex-shrink: 0;
  width: auto;
  margin-bottom: 10px;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    flex-direction: column;
    align-items: center;
    &>div{
      margin-bottom: 20px;
    }
    &>a{
      margin-bottom: 20px;
    }
  `}
`
const SortBox = styled.div`
  width: 1180px;
  margin: -40px auto 36px;
  ${({ theme }) => theme.mediaWidth.upToBigerLarge`
    width: 904px;
  `}

  ${({ theme }) => theme.mediaWidth.upToLarge`
    width: 628px;
  `}

  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 605px;
  `}

  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: calc(100% - 40px);
    justify-content: center;
    margin-top: 30px;
  `}
`
const LIMIT = 500
export default function UserCollected ({ owner }: { owner: string }) {
  const { chainId, account } = useActiveWeb3React()
  const theme = useContext(ThemeContext)
  const exchangeNfts2Address = contractAddresses.exchangeNFTs2[chainId as number]

  const defaultOption = UserTabOptions[0];
  const [curSelect, setCurSelect] = useState(defaultOption)
  // 加载数据中
  const [loading, setLoading] = useState(false)
  // 已经加载全部
  const [loadedAll, setLoadedAll] = useState(false)
  // api获取的nft
  const [artworkApiList, setArtworkApiList] = useState<any[]>([])
  // 获取用户合约里的nft卡片
  const getUserArtworks = useUserArtworks(owner)
  // offer made 数据
  const [userOfferMadeList, setUserOfferMadeList] = useState<any[]>([])
  // sell 数据
  const [userSellList, setUserSellList] = useState<any[]>([])
  // auction 数据
  const [userAuctionList, setUserAuctionList] = useState<any[]>([])
  // 显示在页面的nft卡片
  const [artworkList, setArtworkList] = useState<any[]>([])
  // 总数量
  const [totalNFT, setTotalNFT] = useState(0)
  
  // 搜索框
  const [curValue, setCurValue] = useState('')
  const [searchValue, setSearchValue] = useState('')
  const inputChange = useCallback((e: any) => {
    setCurValue(e.target.value)
  }, [])
  const searchHandle = (value: string) => {
    setSearchValue(value)
  }

  // 查询条件更新数据
  const updateData = useCallback((d) => {
    setCurSelect(d)
    setArtworkApiList([])
  }, [])

  const isLoadAll = useMemo(() => {
    return +totalNFT > 500
  }, [totalNFT])

  // api请求参数 
  let params = {
    limit: LIMIT,
    offset: 0,
    nftType: '-1',
    owner: owner,
    onSale: '-3',
    ids: null,
    keyword: searchValue.trim()
  }

  // 获取api数据
  const getList = useCallback((isAll?: any) => {
    return new Promise((resolve, reject) => {
      getArtworksV2(chainId as number, {
        ...params,
        offset: isAll ? artworkApiList.length : 0
      }, (err: any, data: any) => {
        setLoading(false)
        if (err || data.code !== 0) {
          reject()
          return
        }
        const dataAry = data.data.list || []
        const artworks = dataAry.map((d: ArtworkProps) => {
          let level = (((d.auctionPrice && Number(d.auctionPrice)) && (d.price && Number(d.price) && +d.price === AuctionBake))
          || (d.price && Number(d.price))
          || ((d.auctionPrice && Number(d.auctionPrice)) && !Number(d.price) && (d.owner !== account))) && d.exchangeAddress?.toLowerCase() !== exchangeNfts2Address.toLowerCase() ? 'v2' : 'v3'
          return {
            ...d,
            tokenId: d.nftId,
            nftLevel: level,
            nftType: d.nftType,
            maxBidPrice: (d.maxBidPrice && !Number(d.maxBidPrice)) && (d.auctionPrice && Number(d.auctionPrice)) ? d.auctionPrice.toString() : d.maxBidPrice,
            ...((d.price && Number(d.price)) ? {price: d.price.toString()} : {price: ''}),
            ...((d.auctionPrice && Number(d.auctionPrice)) && (d.price && Number(d.price) && +d.price === AuctionBake) ? {auctionPrice: d.auctionPrice.toString()} : {auctionPrice: ''})
          }
        })
        resolve({list: artworks, count: data.data.count})
      })
    })
  },[getArtworksV2, artworkList, owner, searchValue])

  const fetchApiArtworks = useCallback(async() => {
    params.owner = owner
    params.ids = null
    params.onSale = '-3'
    const artworkList : any = await getList(true)
    setTotalNFT(artworkList.count)

    let newList = []
    newList = [...artworkApiList, ...artworkList.list]
    if (newList.length >= artworkList.count) {
      setLoadedAll(true)
    }
    setArtworkApiList(newList)
  }, [getList])

  // 在竞价/拍卖
  const fetchUserArtworks = useCallback(async() => {
    const userArtworks: any = await getUserArtworks()
    // sell 数据
    let sellList : any = []
    if (userArtworks && userArtworks.inBid && userArtworks.inBid.length) {
      let ids = userArtworks.onAuction.join(',')
      params.ids = ids
      params.owner = owner
      params.onSale = '-3'
      sellList = await getList()
      setUserSellList(sellList.list)
    }

    // auction 数据
    let auctionList : any = []
    if (userArtworks && userArtworks.inBid && userArtworks.inBid.length) {
      let ids = userArtworks.onAuction.join(',')
      params.ids = ids
      params.owner = owner
      params.onSale = '1'
      auctionList = await getList()
      setUserAuctionList(auctionList.list)
    }

     // offer made 数据
     let offerMadeList : any = []
     if (userArtworks && userArtworks.inBid && userArtworks.inBid.length) {
       let ids = userArtworks.inBid.join(',')
       params.ids = ids
       params.owner = ''
       params.onSale = '-3'
       offerMadeList = await getList()
       setUserOfferMadeList(offerMadeList.list)
     }
  }, [getUserArtworks, getList])

  // 整合数据
  const fetchList = useCallback(async() => {
    // in wallet
    let inWalletList : any = []
    inWalletList = artworkApiList.filter((ele:any) => !Number(ele.price))
   
    // sell
    let sellList : any = []
    sellList = userSellList.filter((ele:any) => Number(ele.price) !== Number(AuctionBake))

    // auction
    let auctionList : any = []
    auctionList = userAuctionList.filter((ele:any) => Number(ele.price) === Number(AuctionBake))

     // offer made
     let offerMadeList : any = []
     let allListIds = artworkApiList.map((ele:any) => ele.id)
     offerMadeList = userOfferMadeList.filter((ele:any) => !allListIds.includes(ele.id))

    //  bid
    const bidList : any = userOfferMadeList

    // 合并数据
    let newList:any = []
    switch(curSelect.key){
      case 1: 
        if (isLoadAll) {
          newList = [...artworkApiList]
        } else {
          newList = [...artworkApiList, ...offerMadeList]
        }
        break
      case 2:
        newList = [...inWalletList]
        break
      case 3:
        newList = [...sellList]
        break
      case 4:
        newList = [...auctionList]
        break
      case 5:
        newList = [...bidList]
        break
      default:
        if (isLoadAll) {
          newList = [...artworkApiList]
        } else {
          newList = [...artworkApiList, ...offerMadeList]
        }
        break
    }
    if (newList.length < LIMIT) {
      setLoadedAll(true)
    }
    setArtworkList(newList)
  }, [artworkApiList,userSellList, userAuctionList, userOfferMadeList])

  const loadmore = useCallback(() => {
    setLoading(true)
  }, [])

  // Init List
  useEffect(() => {
    setLoading(true)
    setArtworkList([])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chainId, curSelect, owner, searchValue])

  // 初始化合约数据、api数据
  useEffect(() => {
    if (!loading) return
    fetchApiArtworks()
    fetchUserArtworks()
  }, [loading])

  // 整合数据
  useEffect(() => {
    fetchList()
  }, [fetchList])

  // const options = UserTabOptions.filter(ele => ele.key !== 5);
  return (
    <>
      <Loading open={loading} />
      <SortBox>
        <MyEggsRow style={{justifyContent: 'flex-end'}}>
          <Search value={curValue} inputChange={inputChange} searchHandle={searchHandle}></Search>
          {
            artworkList.length > 500 ? null :
            <SortPets
              bg={theme.bsBg30}
              wd="115px"
              height={32}
              margin="0 15"
              curSelect={curSelect}
              options={UserTabOptions}
              updateData={option => updateData(option)}
            ></SortPets>
          }
        </MyEggsRow>
      </SortBox>
      {
        artworkList.length ? 
        <InfiniteScroll loading={loading} loadedAll={loadedAll} loadmore={loadmore}>
          <ArtworkList>
            {
              artworkList.map((d) => {
                return (
                  <ArtworkCard key={d.id} artwork={d}></ArtworkCard>
                )
              })
            }
          </ArtworkList>
        </InfiniteScroll>
        : !loading && <NoArtwork />
      }
    </>
  )
}